module.exports = __webpack_public_path__ + "img/history-blue.d7458cbd.svg";